import { render, staticRenderFns } from "./PaperScore.vue?vue&type=template&id=b569dcb2&scoped=true"
import script from "./PaperScore.vue?vue&type=script&lang=js"
export * from "./PaperScore.vue?vue&type=script&lang=js"
import style0 from "./PaperScore.vue?vue&type=style&index=0&id=b569dcb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b569dcb2",
  null
  
)

export default component.exports